document.addEventListener('DOMContentLoaded', function () {
  function initProductSectionsSlider() {
    var idProductSections = 'product-sections',
        selectorBPListed = '.wb-bundle_product-listed',
        selectorSwiper = '.product-section-slider.swiper-container',
        selectorSwiperWrapper = '.swiper-wrapper',
        selectorSlideInit = '.swiper-slide--init',
        selectorSection = '.product-section',
        selectorBottomContainer = '.product-section-slider__bottom-container',
        classSlide = 'swiper-slide';
    
    var elProductSections = document.getElementById(idProductSections);
    if (!elProductSections) {
      return; 
    }
    var elSwipers = Array.prototype.slice.call(elProductSections.querySelectorAll(selectorSwiper));

    elSwipers = elSwipers.map(function (elSwiper) {
      var elSlideInit = elSwiper.querySelector(selectorSlideInit);
      if (!elSlideInit) {
        return; 
      }
      var elWrapper = elSwiper.querySelector(selectorSwiperWrapper);
      var elSections = Array.prototype.slice.call(elSlideInit.querySelectorAll(selectorSection));
      if (elSections.length < 1) {
        var elParent = elSwiper.closest(selectorBPListed);
        elProductSections.removeChild(elParent);
        return;
      }
      elSections.forEach(function (elSection) {
        var elSlide = document.createElement('div');
        elSlide.className = classSlide;
        if (elSection.dataset.swiperNavigationColor) {
          elSlide.dataset.swiperNavigationColor = elSection.dataset.swiperNavigationColor;
        }
        elSlide.appendChild(elSection);
        elWrapper.appendChild(elSlide);
      });
      elWrapper.removeChild(elSlideInit);

      return elSwiper;
    }).filter(function (elSwiper) {
      return typeof elSwiper !== 'undefined';
    });
    
    setTimeout(function () {
      elSwipers.forEach(function (elSwiper) {
        function updateNavigationColor(swiper) {
          var slide = swiper.slides[swiper.activeIndex];
          if (slide && slide.dataset.swiperNavigationColor) {
            elSwiper.querySelector(selectorBottomContainer).style.color = slide.dataset.swiperNavigationColor;
          } else {
            elSwiper.querySelector(selectorBottomContainer).style.color = null;
          }
        }

        var sliderId = '#' + elSwiper.getAttribute('id');
        var swiper = new Swiper(elSwiper, {
          on: {
            init: function() {
              var swiper = this;
              if (swiper.slides.length - (swiper.loopedSlides * 2) < 2) {
                elSwiper.querySelector(selectorBottomContainer).style.display = 'none';
              }
              updateNavigationColor(swiper);
            },
            slideChange: function() {
              var swiper = this;
              updateNavigationColor(swiper);
            }
          },
          navigation: {
            nextEl: sliderId + ' .product-section-slider__nav-next',
            prevEl: sliderId + ' .product-section-slider__nav-prev',
            disabledClass: 'product-section-slider__nav--disabled',
            hiddenClass: 'product-section-slider__nav--disabled'
          },
          pagination: {
            el: sliderId + ' .product-section-slider__pagination',
            clickable: true,
            bulletClass: 'product-section-slider__bullet',
            bulletActiveClass: 'product-section-slider__bullet--active'
          },
          slidesPerView: 1,
          spaceBetween: 1,
          loop: true,
          autoHeight: true,
          roundLengths: true, //prevent blurry text
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            invert: true
          },
          lazyLoad: true,
          initialSlide: parseInt(elSwiper.getAttribute('data-swiper-initial-slide') || 0)
        });
      });
    }, 1000);
  }

  initProductSectionsSlider();

}, { passive: true });